import * as React from "react";

const CameraIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    fill="none"
    viewBox="0 0 30 30"
    className={className}
  >
    <g
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_2523_19120)"
    >
      <path d="M5.625 24.375h18.75A1.875 1.875 0 0 0 26.25 22.5V9.375A1.875 1.875 0 0 0 24.375 7.5h-3.75L18.75 4.688h-7.5L9.375 7.5h-3.75A1.875 1.875 0 0 0 3.75 9.375V22.5a1.875 1.875 0 0 0 1.875 1.875"></path>
      <path d="M15 19.688a4.219 4.219 0 1 1 0-8.438 4.219 4.219 0 0 1 0 8.438"></path>
    </g>
    <defs>
      <clipPath id="clip0_2523_19120">
        <path fill="#fff" d="M30 0H0v30h30z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default CameraIcon;
